import React, { useState, useEffect } from 'react';
import './TopSectionComponent.scss';
import { TopSectionComponentProps } from '../../constants/interface';
import { useTranslation } from 'react-i18next';
import '@fortawesome/fontawesome-free/css/all.min.css';

const TopSectionComponent = (props: TopSectionComponentProps) => {
    const { title, topText, topTextIcon, text, buttons } = props;
    const {t} = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
        }, 3000); // Change content every 3 seconds

        return () => clearInterval(interval);
    }, []);
    
    return (
        <div id="top-section-container-parent" className='relative bg-no-repeat bg-cover' style={{ backgroundImage: `url(${carouselItems[currentIndex]?.img})` }}>
            <div className="absolute w-full h-full bg-[#021d78b3]">
                {/* <div className="absolute w-full h-full bg-blue-223-b3"></div> */}
            </div>
            <div id="top-section-container" className="section grid grid-rows-[1fr_max-content]" >
                <div className="grid gap-16 py-24 lg:py-0">
                    <div className="content lg:text-center">
                        {/* Add any content you want to display on top of the image */}
                        <div className="grid gap-12">
                            <div className="grid gap-2 lg:gap-6">
                                <p className="text-xs font-semibold lg:text-base">{t(topText)} {topTextIcon || ''}</p>
                                <p className="text-[2.5rem] font-semibold lg:text-7xl lg:w-[49rem] lg:m-auto">{t(title)}</p>
                                <p className="text-base font-normal max-w-[38rem] lg:m-auto">{t(text)}</p>
                            </div>
                            <>
                                {
                                    (buttons?.length > 0) &&
                                    (<div className="btn-container justify-center">
                                        {
                                            buttons.map((item, index: number) => (
                                                <button key={index} className={`btn ${item.className}`}
                                                    onClick={() => item.onBtnClick && item.onBtnClick(item)}
                                                    >
                                                    <span>{t(item.title)}</span>
                                                    <>
                                                        {
                                                            (item.icon) &&
                                                            <i className={`fa-solid pt-[0.125rem] ${item.icon}`}></i>
                                                        }
                                                    </>
                                                    <>
                                                        {
                                                            (item.img) &&
                                                            <img loading="lazy" src={item.img} alt={item.title} />
                                                        }
                                                    </>
                                                </button>
                                            ))
                                        }
                                    </div>)
                                }
                            </>
                        </div>
                    </div>
                </div>
                <div  className="bottom-container px-5 2xl:px-0">
                    <img className="animate-spin" loading="lazy" src={"/assets/images/png/home-page-icon-1.webp"} alt="" />
                </div>
            </div>
        </div>
    );
};

export default TopSectionComponent;

const carouselItems = [
    { img: '/assets/images/png/home-page-top-bg-1.webp' },
    { img: '/assets/images/png/home-page-top-bg-2.webp' },
];